<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">
            <h2>Remplacer le jeu "{{ title }}"</h2>
            <img :src="'/games/static/miniatures/'+image_url" width="200" />
            <br /><br />
            
            <label>Rechercher le jeu à mettre en avant </label>
            <input type="text" :value="recherche" @input="recherche= $event.target.value" @keyup="searchAllGames" />
            
            <!-- <div class="search-results"> -->
            <div>
                <li v-for="game in foundGames" :key="game.title" @click="featureGame(game)">
                    <img :src="'/games/static/miniatures/'+game.image_url" width="80" />
                    <!-- <div class="img"><div class="background" :style="{'background-image' : 'url(\'/games/static/miniatures/'+game.image_url+'\')'}"></div></div> -->
                    <div class="right">
                        <p>{{ game.title }}</p>
                    </div>
                </li>
                
                <li class="no-results" v-if="recherche.trim().length > 0 && foundGames.length <= 0">Aucun résultat</li>
            </div>
            
            <p v-if="alerte">{{ alerte }}</p>
        </div>
    </div>
</template>

<script>
    import Session from '../mixins/adminSession';
    import AdminNavbar from '../views/AdminNavbar';

    export default {
        name: 'AdminFeatureGame', 
        mixins: [Session],
        components: {
            'admin-navbar': AdminNavbar
        },
        data() {
            return {
                id: 0,
                title: '',
                image_url: '',

                foundGames: [],
                recherche: '',

                alerte: ''
            }
        },
        mounted() {
            this.id = this.$route.params.gameId;
            this.getFeaturedGame();
        },
        methods: {
            getFeaturedGame() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({
                    post: "1",
                    featureId: this.id
                }));
                
                axios
                .post(this.$store.state.apiUrl+"?request=getFeaturedGame", formData)
                .then((response) => {
                    if(response.data.id) {
                        this.title = response.data.title;
                        this.image_url = response.data.image_url;
                    }
                    else {
                        this.$router.push('../featureGames');
                    }
                })
                .catch((error) => this.$router.push('../featureGames'));
            },
            searchAllGames() {
                if(this.recherche.trim().length > 0) {
                    let formData = new FormData();
                    formData.append('data', JSON.stringify({post: "1", search: this.recherche}));

                    axios
                    .post(this.$store.state.apiUrl+"?request=searchAllGames", formData)
                    .then((response) => {
                        if(response.data.length > 0) {
                            this.foundGames = response.data;
                        }
                        else {
                            this.foundGames = [];
                        }
                    });
                }
                else {
                    this.foundGames = [];
                }
            },
            featureGame(game) {
                if (confirm('Souhaitez-vous vraiment mettre le jeu "'+ game.title +'" en avant ?')) {
                    let data = JSON.stringify({
                        post: '1',
                        featureId: this.id,
                        gameId: game.id,
                    });
                    
                    let formData = new FormData();
                    formData.append('data', data);

                    axios
                    .post(this.$store.state.apiUrl+"?request=featureGame", formData)
                    .then((response) => {
                        if(response.data) {
                            this.alerte = "Le jeu a bien été ajouté parmi les jeux mis en avant";
                        }
                        else {
                            this.alerte = "Le jeu n'a pas été ajouté parmi les jeux mis en avant";
                        }
                    })
                    .catch((error) => this.alerte = "Le jeu n'a pas pu être ajouté parmi les jeux mis en avant");
                }
            }
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
